import React from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import FraudTab from './FraudTab';
import axios from 'axios';
import { getKeymakerApiKey } from "../../../graphql/keymakerApiKey";

import {
  Card,
  CardHeader,
  CardContent,
  CardActions,
  Divider,
  Button
} from '@material-ui/core';
import { GET_ENGINE } from 'common/GQLRequests';
import { getDynamicConfigValue } from '../../../dynamicConfig';

const useStyles = makeStyles(() => ({
  root: {
    width: '100%'
  },
  actions: {
    justifyContent: 'center'
  },
  cardContent: {
    height: 230,
    overflowX: 'scroll',
    overflowY: 'scroll'
  }
}));
var source;
const FraudFilters = props => {
  const {
    className,
    parentCallback,
    loadCallback,
    id,
    drillEngine,
    setSelectedCard,
    setAccountHolder,
    setAssociation,
    accountID,
    phaseParameters,
    phaseIdMap,
    currentID,
    alternatePhaseIdMap,
    mode,
    ...rest
  } = props;
  const classes = useStyles();

  const setPhaseParameter = (engine, key, value) => {
    if (phaseParameters[engine] === undefined) {
      phaseParameters[engine] = {};
    }
    phaseParameters[engine][key] = value;
  };
  const getPhaseParameters = engine => {
    return phaseParameters[engine];
  };
  const handleSubmit = (engine, phaseList) => {
    setAssociation(undefined);
    const pMap = getPhaseParameters(engine);
    const paramString = Object.keys(pMap)
      .map(key => {
        return key + ':' + pMap[key];
      })
      .join(',');
    if (mode === true)
      getRecommendationsByPhases(
        phaseList,
        paramString + `,customerID:${accountID}`
      );
    else getRecommendationsByPhases(phaseList, paramString);
  };

  const getRecommendationsByPhases = async (phaseId, params) => {
    localStorage.setItem('InputParams', params);
    localStorage.setItem('isAssociation', false);
    if (source) {
      source = source.cancel();
    }
    source = axios.CancelToken.source();
    console.log(source.token);
    loadCallback(true);
    setSelectedCard(-1);
    setAccountHolder(-1);
    parentCallback(undefined);
    //source = await source.cancel()

    // const keymakerApiKey = getDynamicConfigValue('REACT_APP_KEYMAKER_API_KEY');
    const keymakerApiKey = getKeymakerApiKey();
    await axios
      .post(
        getDynamicConfigValue('REACT_APP_RECOMMENDATION_URI'),
        {
          query: `
         query {
           recommendations:recommendationsForPhases(
             phaseID: [${phaseId}]
             params: { ${params} }
             first: 25
             skip: 0
           ) {
             item
             score
             details
           }
         }
       `
        },
        {        
          headers: { 
            "api-key": keymakerApiKey
          },
          cancelToken: source.token
        }
      )
      .then(result => {
        loadCallback(false);
        const { data } = result;
        if (data.errors === undefined) {
          parentCallback(data);
        } else {
          parentCallback(undefined);
          alert('Check your Input...');
        }
      })
      .catch(error => {
        if (axios.isCancel(error)) {
          console.log('previous Cancelled');
        } else {
          loadCallback(false);
          parentCallback(undefined);
          alert('Check your Input...');
        }
      });
  };
  return (
    <Card {...rest} className={clsx(classes.root, className)}>
      <CardHeader
        titleTypographyProps={{ variant: 'h4', style: { color: '#455a64' } }}
        title={currentID + ' Parameters'}
      />
      <Divider />
      <CardContent className={classes.cardContent}>
        <FraudTab
          selectedQuery={GET_ENGINE}
          drillEngine={drillEngine}
          selectedValue={id}
          parentCallback={parentCallback}
          setPhaseParameter={setPhaseParameter}
          phaseIdMap={phaseIdMap}
          alternatePhaseIdMap={alternatePhaseIdMap}
        />
      </CardContent>
      <Divider />
      <CardActions className={classes.actions}>
        <Button
          position="right"
          color="secondary"
          size="medium"
          variant="outlined"
          style={{ fontWeight: '500', border: '1px solid' }}
          onClick={() => {
            const phaseList = Object.keys(phaseIdMap).filter(
              key => phaseIdMap[key] === true
            );
            console.log(phaseList);
            handleSubmit(id, phaseList);
          }}>
          {' '}
          Submit
        </Button>
      </CardActions>
    </Card>
  );
};

FraudFilters.propTypes = {
  className: PropTypes.string
};

export default FraudFilters;
